import { useState } from 'react';
import { testimonials } from '@/mocks/homeMocks';

export default function TestimonialSection() {
  const [current, setCurrent] = useState(0);

  const prev = () => {
    setCurrent((c) => (c === 0 ? testimonials.length - 1 : c - 1));
  };

  const next = () => {
    setCurrent((c) => (c === testimonials.length - 1 ? 0 : c + 1));
  };

  const t = testimonials[current];

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="w-full lg:w-[40%] shrink-0">
            <div className="relative rounded-2xl overflow-hidden aspect-[3/4] lg:aspect-[4/5] max-w-sm mx-auto">
              <img
                src={t.avatar}
                alt={t.name}
                title={`${t.name} - 韩漫大全真实读者`}
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="flex-1 max-w-xl">
            <span className="text-xs font-medium text-foreground-500 tracking-wider">
              （真实读者评价）
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-2 mb-8">
              听听读者们
              <br />
              <span className="text-foreground-400">怎么说</span>
            </h2>

            <blockquote className="text-base md:text-lg text-foreground-700 leading-relaxed mb-8">
              &ldquo;{t.content}&rdquo;
            </blockquote>

            <div className="flex items-end justify-between">
              <div>
                <p className="font-heading font-bold text-foreground-950">
                  &mdash; {t.name}
                </p>
                <p className="text-sm text-foreground-500">{t.level}</p>
              </div>

              <div className="flex items-center gap-3">
                <button
                  onClick={prev}
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-200 text-foreground-600 hover:border-foreground-400 transition-colors cursor-pointer"
                  aria-label="上一条评价"
                >
                  <i className="ri-arrow-left-line"></i>
                </button>
                <button
                  onClick={next}
                  className="w-11 h-11 flex items-center justify-center rounded-full bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer"
                  aria-label="下一条评价"
                >
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </div>

            <div className="flex items-center gap-2 mt-6">
              {testimonials.map((_, idx) => (
                <button
                  key={idx}
                  onClick={() => setCurrent(idx)}
                  className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                    idx === current
                      ? 'bg-accent-500 w-6'
                      : 'bg-foreground-200 hover:bg-foreground-300'
                  }`}
                  aria-label={`第${idx + 1}条评价`}
                ></button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}